import { Link } from "react-router-dom";

const quickLinks = [
  { label: "赛事分类", to: "/category/season" },
  { label: "赛季赛程", to: "/schedule/2025-26" },
  { label: "直播中心", to: "/live/m-live-01" },
  { label: "资讯新闻", to: "/news" },
];

const topTeams = [
  { label: "曼城", to: "/team/man-city" },
  { label: "皇家马德里", to: "/team/real-madrid" },
  { label: "拜仁慕尼黑", to: "/team/bayern" },
  { label: "巴塞罗那", to: "/team/barcelona" },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-youtube-fill", label: "视频号" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-auto">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-background-50 text-xl">
                <i className="ri-football-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">欧冠直播</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200">
              专注欧洲冠军联赛的实时直播入口、完整赛程、球队资料与赛事资讯，为足球爱好者提供一站式欧冠信息平台。
            </p>
            <div className="flex items-center gap-2 mt-5">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-white/10 text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors"
                >
                  <i className={s.icon} aria-hidden="true"></i>
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <Link to="/about">快速导航</Link>
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <Link to="/category/season">热门球队</Link>
            </h4>
            <ul className="space-y-2.5">
              {topTeams.map((t) => (
                <li key={t.to}>
                  <Link
                    to={t.to}
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors"
                  >
                    {t.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <Link to="/about">服务说明</Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li>赛事直播入口与赛程查询</li>
              <li>球队资料与阵容数据展示</li>
              <li>欧冠资讯与赛后战报</li>
              <li>内容均为演示数据，仅供参考</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © 2026 欧冠直播 UCL LIVE · 本站赛事与资讯内容均为虚构演示，不代表任何官方组织
          </p>
          <div className="flex items-center gap-4 text-xs text-background-300">
            <Link to="/about" className="hover:text-accent-400 transition-colors">
              关于我们
            </Link>
            <Link to="/news" className="hover:text-accent-400 transition-colors">
              资讯中心
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}